const env = {
  API: {
    URL: window?._env_?.API_URL || '',
    MODULO: window?._env_?.MODULO || '/temba/v1',
  },
  RECAPTCHA: {
    SCRIPT: window?._env_?.SCRIPT_CAPTCHA || '',
    KEY_V2: window?._env_?.RECAPTCHA_KEY_V2 || '',
    KEY_V3: window?._env_?.RECAPTCHA_KEY_V3 || '',
  },
  PUBLIC_KEY: window?._env_?.PUBLIC_KEY || '',
  LANDING: window?._env_?.LANDING || ''
};

export default env;
